<pre class="code-block">
    <div class="code-block-header">
        <span *ngIf="title">{{ title }}</span>
        <span class="lang" *ngIf="!title">{{ language }}</span>
        <button type="button" class="copy-btn" [class.copied]="copied" (click)="copy()">
            <mat-icon>{{ copied ? 'check' : 'content_copy' }}</mat-icon>
            {{ copied ? 'Copiado' : 'Copiar' }}
        </button>
    </div>
    <code #codeEl [class]="'language-' + language">{{ code }}</code>
</pre>
